import React, { useState, useRef } from "react";
import { motion } from "framer-motion";

const DEFAULT_IMG = "/images/document-logo.png";

const CategoryItem = ({ name = "", image, onClick, animationDelay = 0 }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);
  const hasAnimated = useRef(false);
  const src = !imgError && image ? image : DEFAULT_IMG;

  return (
    <motion.button
      type="button"
      onClick={onClick}
      aria-label={`Danh mục ${name}`}
      initial={hasAnimated.current ? false : { opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18, delay: animationDelay }}
      onAnimationComplete={() => {
        hasAnimated.current = true;
      }}
      whileHover={{ y: -2, scale: 1.02 }}
      whileTap={{ scale: 0.97 }}
      className="
        group relative flex w-full flex-col items-center justify-center
        aspect-square min-h-[148px]
        rounded-xl border border-[#B7D4FF] bg-white p-3 shadow-sm
        transition-[border-color,box-shadow,transform] duration-200
        hover:border-[#7DB5FF] hover:shadow-md
        focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0155F8]/25 focus-visible:ring-offset-2
      "
    >
      <div className="relative flex h-[76px] w-[76px] items-center justify-center rounded-xl bg-white p-2 shadow-[0_8px_20px_rgba(1,85,248,0.08)]">
        {!imgLoaded && (
          <span className="absolute inset-2 animate-pulse rounded-lg bg-blue-50" />
        )}
        <img
          src={src}
          loading="lazy"
          alt=""
          onLoad={() => setImgLoaded(true)}
          onError={() => {
            setImgError(true);
            setImgLoaded(true);
          }}
          className={`h-full w-full rounded-lg object-contain object-center transition-opacity duration-200 ${
            imgLoaded ? "opacity-100" : "opacity-0"
          }`}
        />
      </div>

      <span
        className="
          mt-3 line-clamp-2 w-full text-center text-[13.5px] leading-tight
          font-sf-bold text-slate-700 group-hover:text-[#0155F8]
        "
        style={{
          fontFamily: '"SF Pro Display Bold", sans-serif',
          fontWeight: 700,
        }}
        title={name}
      >
        {name}
      </span>
    </motion.button>
  );
};

export default CategoryItem;
